export default __webpack_public_path__ + "images/9f13ebd973ec620d70871b8f8d151c53.svg";